<script>
import {useOverviewStore} from "../../stores/overview";
import {useAnalyticEventStore} from "../../stores/analyticEvents";

export default {
  name: "DonationPaymentChart",
  setup() {
    const overviewStore = useOverviewStore();
    const analyticEventStore = useAnalyticEventStore();
    return {
      overviewStore,
      analyticEventStore
    };
  },
  data() {
    return {
      tabs: ['donations-tab', 'payments-tab'],
      activeTab: 'donations-tab',
      previousTab: null
    };
  },
  methods: {
    recordAnalyticEvent(action) {
      this.analyticEventStore.setOrganizationId(this.overviewStore.organizationId);
      this.analyticEventStore.logEvent({
        action: action
      });
    },
    switchTab(tab){
      if(tab !== this.activeTab) {
        this.previousTab = this.activeTab;
        this.activeTab = tab;
      }
    },
    beforeEnter(el){
      el.style.transform = `translateX(${this.previousTab === 'donations-tab' && this.activeTab === 'payments-tab' ? '100%' : '-100%'})`;
    },

    enter(el, done){
      // Trigger reflow
      el.offsetWidth; // eslint-disable-line  @typescript-eslint/no-unused-expressions
      el.style.transition = 'transform 0.3s ease-in-out';
      el.style.transform = 'translateX(0)';
      done();
    },

    leave(el, done){
      el.style.transition = 'transform 0.3s ease-in-out';
      el.style.transform = `translateX(${this.previousTab === 'donations-tab' && this.activeTab === 'payments-tab' ? '-100%' : '100%'})`;
      done();
    }
  }
};
</script>

<template>
  <div class="w-full h-full overflow-hidden">
    <div class="relative w-full mx-auto overflow-hidden h-full text-xs">
      <!-- Tab headers -->
      <div class="flex flex-row">
        <button
          :class="[{ 'active': activeTab === 'donations-tab'}]"
          class="tab-btn"
          @click="switchTab('donations-tab'); recordAnalyticEvent('dashboard-overview-switch-to-donations-tab')"
        >
          Gifts
        </button>
        <button
          :class="[{ 'active': activeTab === 'payments-tab'}]"
          class="tab-btn"
          @click="switchTab('payments-tab'); recordAnalyticEvent('dashboard-overview-switch-to-payments-tab')"
        >
          Dollars
        </button>
      </div>
      <div class="overflow-hidden h-full">
        <!-- Tab content with sliding animation -->
        <transition
          name="slide"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
        >
          <div
            :key="activeTab"
            class="tab-content h-full max-h-[300px]"
          >
            <div
              v-show="activeTab === 'donations-tab'"
              class="tab-pane"
            >
              <slot name="donation-chart" />
            </div>
            <div
              v-show="activeTab === 'payments-tab'"
              class="tab-pane"
            >
              <slot name="payment-chart" />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

.tab-pane{
  background-color: white;
}
.tab-btn {

  @apply flex-1;
  @apply py-2;
  @apply text-center;
  @apply p-1;
  @apply transition-colors;
  @apply duration-300;
  @apply bg-white text-gray-500;
  @apply mr-2;

  font-weight: bold;
  font-size: 1.1em;
  max-width: 100px;

  &:hover {
    //@apply bg-default_primary_lightest;
  }

  &.active {
    border-bottom: 3px solid #08602d;
  }

}
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease-in-out;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.slide-leave {
  transform: translateX(-100%);
}
</style>
